module.exports = __webpack_public_path__ + "static/media/bandera-francesa.2f9befe9.svg";